<template>
  <div class="season-list">
    <div class="select-div">
      <select class="select-box" v-model="seasonSelect" :class="{placeholder: isEmpty(seasonSelect)}">
        <option value="null" disabled hidden selected>시즌권을 선택하세요.</option>
        <option
          v-for="(ver, i) in seasonList"
          :key="i"
          :value="ver.season_pass_no">
          {{ver.seat_info.season_number}}
        </option>
      </select>
      <button class="id-check" @click="seasonTicketInquiry">시즌권 조회</button>
    </div>

    <div class="season-table-div">
      <table class="season-table">
        <caption>시즌권 사용내역</caption>
        <thead>
          <tr>
            <td v-for="(item, index) in theadList" :key="index">{{item}}</td>
          </tr>
        </thead>
        <tbody v-if="usageHistory.length > 0">
          <tr v-for="(item, index) in usageHistory" :key="index">
            <td>
              <p class="pc">{{item.game_date}}({{item.game_yoil}})</p>
              <p class="mobile">{{item.mdate}}</p>
            </td>
            <td>
              <div>
                <span>VS</span><img :src="getEmblem(item.away_team)">{{item.away_team_name}}
              </div>
            </td>
            <td>{{item.entrance_time ? item.entrance_time : '-'}}</td>
            <td>{{item.entrance_state_code === 'Y' ? '입장' : '미입장'}}</td>
          </tr>
        </tbody>
        <tbody v-else class="tbody-empty">
        <tr>
          <td colspan="4" class="center">
            <div class="empty"></div>
            <p>내역이 없습니다.</p>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {getEmblem, isEmpty} from '@/lib';
import dayjs from "dayjs";

export default {
  name: 'TicketSeasonList',
  data() {
    return {
      seasonSelect: null,
      seasonList: [],
      theadList: ['경기일자', '예매경기', '입장시간', '입장여부'],
      usageHistory: []
    }
  },
  mounted () {
    this.getSeasonTicket();
  },
  methods: {
    isEmpty,
    getEmblem,
    async getSeasonTicket() {
      const {data} = await this.$http.get('/ticket/season');
      if(data.success && data.list.length > 0) {
        this.seasonList = data.list;
      } else {
        this.seasonList = [];
      }
    },
    async seasonTicketInquiry() {
      if(isEmpty(this.seasonSelect)) {
        alert('시즌권을 선택하세요.');
        return false;
      }

      const {data} = await this.$http.get(`/ticket/season/${this.seasonSelect}?page=1&limit=999`);
      if(data.success && data.list.length > 0) {
        this.usageHistory = data.list;

        this.usageHistory.map(item => {
          item.mdate = dayjs(item.game_date).format('MM.DD');
          item.game_date = dayjs(item.game_date).format('YYYY.MM.DD');
        })

      } else {
        this.usageHistory = [];
      }

    },
  }
}
</script>
